var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeografia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-geografia-1{fill:#464af0;}.subject-geografia-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Geografia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3416",
    "data-name": "Path 3416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M24.76,38.26a13.51,13.51,0,1,1,13.5-13.5A13.52,13.52,0,0,1,24.76,38.26Zm0-25.51a12,12,0,1,0,12,12A12,12,0,0,0,24.76,12.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3412",
    "data-name": "Path 3412"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M24.75,37.88a.38.38,0,0,1-.26-.11c-.27-.26-6.49-6.56-6.49-13s6.22-12.76,6.49-13a.39.39,0,0,1,.41-.09.38.38,0,0,1,.23.35V37.51a.36.36,0,0,1-.23.34ZM24.38,13c-1.6,1.8-5.63,6.84-5.63,11.8s4,10,5.63,11.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3413",
    "data-name": "Path 3413"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M24.75,37.88a.2.2,0,0,1-.11,0c-.1,0-9.83-3.38-9.83-13.1s9.73-13.08,9.83-13.11a.36.36,0,0,1,.38.09c.26.26,6.48,6.55,6.48,13s-6.22,12.76-6.48,13A.39.39,0,0,1,24.75,37.88Zm-.1-25.44c-1.4.54-9.09,3.93-9.09,12.32s7.69,11.77,9.09,12.31c1-1,6.11-6.74,6.11-12.32S25.65,13.49,24.65,12.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3414",
    "data-name": "Path 3414"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M24.75,37.88a.38.38,0,0,1-.33-.2c-.13-.27-3.23-6.53-3.23-12.92s3.1-12.66,3.23-12.93a.39.39,0,0,1,.45-.19c.1,0,9.82,3.39,9.82,13.11S25,37.83,24.87,37.86A.25.25,0,0,1,24.75,37.88Zm.19-25.41c-.61,1.34-3,6.85-3,12.29s2.39,10.94,3,12.28c1.62-.65,9-4.07,9-12.29S26.56,13.12,24.94,12.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3415",
    "data-name": "Path 3415"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M24.75,37.89a.47.47,0,0,1-.16,0,.38.38,0,0,1-.17-.51c0-.06,3.15-6.37,3.15-12.58s-3.12-12.53-3.15-12.59a.38.38,0,0,1,.67-.34c.13.27,3.23,6.53,3.23,12.93s-3.1,12.65-3.23,12.92A.39.39,0,0,1,24.75,37.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_28",
    "data-name": "Line 28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-geografia-2",
    d: "M37.51,25.13H12a.38.38,0,0,1,0-.75H37.51a.38.38,0,0,1,0,.75Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeografia);
export default __webpack_public_path__ + "static/media/geografia.dbd3cb1bdd51bc3642ac02557d0bf4b0.svg";
export { ForwardRef as ReactComponent };